// extracted by mini-css-extract-plugin
export default {"breakpoint_tablet_max_width_1199":"1199px","t_img_container":"fas_t_img_container","t_img":"fas_t_img","pf_result":"fas_pf_result","on_hover":"fas_on_hover"};